import { InMemoryStorage } from "./InMemoryStorage";

export const isSessionStorageSupported = () => {
  if (typeof window === 'undefined') return false;
  let supported = true;
  try {
    sessionStorage.setItem("support", "true");
    sessionStorage.removeItem("support");
  } catch (e) {
    console.warn(
      "SessionStorage is not supported. Defaulting to memory storage."
    );
    supported = false;
  }
  return supported;
};

const SessionManager = () => {
  const ID_TOKEN_KEY = "id_token";
  const ACCESS_TOKEN_KEY = "access_token";
  const REFRESH_TOKEN_KEY = "refresh_token";
  const TOKEN_EXPIRATION_KEY = "token_expiration";
  const ORIGIN_URL = "origin-url";

  let _storage = null;
  
  const getStorage = () => {
    if (!_storage) {
      _storage = isSessionStorageSupported()
        ? sessionStorage
        : InMemoryStorage();
    }
    return _storage;
  };

  const setOriginUrl = (url) => {
    getStorage().setItem(ORIGIN_URL, url);
  };

  const setIdToken = (id_token) => {
    getStorage().setItem(ID_TOKEN_KEY, id_token);
  };

  const setAccessToken = (access_token) => {
    getStorage().setItem(ACCESS_TOKEN_KEY, access_token);
  };

  const setRefreshToken = (refresh_token) => {
    getStorage().setItem(REFRESH_TOKEN_KEY, refresh_token);
  };

  const setTokenExpiration = (expiration) => {
    getStorage().setItem(TOKEN_EXPIRATION_KEY, expiration);
  };

  const getOriginUrl = () => {
    return getStorage().getItem(ORIGIN_URL);
  };

  const getAccessToken = () => {
    return getStorage().getItem(ACCESS_TOKEN_KEY);
  };

  const getRefreshToken = () => {
    return getStorage().getItem(REFRESH_TOKEN_KEY);
  };

  const getIdToken = () => {
    return getStorage().getItem(ID_TOKEN_KEY);
  };

  const getTokenExpiration = () => {
    return getStorage().getItem(TOKEN_EXPIRATION_KEY);
  };

  const removeOriginUrl = () => {
    getStorage().removeItem(ORIGIN_URL);
  };

  const removeIdToken = () => {
    getStorage().removeItem(ID_TOKEN_KEY);
  };

  const removeAccessToken = () => {
    getStorage().removeItem(ACCESS_TOKEN_KEY);
  };

  const removeRefreshToken = () => {
    getStorage().removeItem(REFRESH_TOKEN_KEY);
  };

  const removeTokenExpiration = () => {
    getStorage().removeItem(TOKEN_EXPIRATION_KEY);
  };

  return {
    setOriginUrl,
    setIdToken,
    setAccessToken,
    setRefreshToken,
    setTokenExpiration,
    getOriginUrl,
    getAccessToken,
    getRefreshToken,
    getIdToken,
    getTokenExpiration,
    removeOriginUrl,
    removeIdToken,
    removeAccessToken,
    removeRefreshToken,
    removeTokenExpiration,
  };
};

export default SessionManager();
